"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/People/OrgPills.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');






/* Account → People's organizations, and API keys' organizations and
 * scopes (F-18): one pill with the full name (cut short with an ellipsis
 * only when the column is too narrow, and named in full on hover), then a
 * small "+N" that lists the rest on hover or keyboard focus. */
const OrgPills = ({ names }) => {
  const [first, ...rest] = names
  if (!first) return null
  return (
    _react2.default.createElement('div', { className: "account-people--pills", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      , _react2.default.createElement('span', { className: "blm-name--badge account-people--pill" , title: first, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  first )
      ,  rest.length > 0 && (
        _react2.default.createElement(_Tooltip.HoverTooltip, {
          type: "dark",
          // Below: the sticky header row would cover it above the first row.
          place: "bottom",
          showOnFocus: true,
          className: "account-people--more-wrap",
          content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}},  rest.map((n, i) => _react2.default.createElement('div', { key: `${i}-${n}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}},  n )) ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

          , _react2.default.createElement('button', {
            type: "button",
            className: "blm-name--badge account-people--more" ,
            'aria-label': `${rest.length} more: ${rest.join(', ')}`,
            onClick: e => e.stopPropagation(),
            onKeyDown: e => e.stopPropagation(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
, "+"
            ,  rest.length 
          )
        )
      )
    )
  )
}

/* Org names for OrgPills: the account's default org first when it's among
 * them, then the rest by name. */
 const orderOrgNames = (keys, orgName, defaultKey) => {
  const rest = keys.filter(k => k !== defaultKey).map(orgName).sort((a, b) => a.localeCompare(b))
  return defaultKey && keys.includes(defaultKey) ? [orgName(defaultKey), ...rest] : rest
}; exports.orderOrgNames = orderOrgNames

exports. default = OrgPills
